namespace $.$$ {

	export class $shm_hitalama_map_widget_tools extends $.$shm_hitalama_map_widget_tools {

		type_name() {
			const type = this.widget().type()
			const title = this.$.$shm_hitalama_map_widget_def_titles[ type ]
			return title || type
		}

		map(): $shm_hitalama_map {
			return this.Map_page().map()
		}
		
		Widget() {
			return this.Map_page().Widget( this.widget().link() ).Sub()
		}

		@ $mol_mem
		title( next?: string ): string {
			return this.widget().title( next )
		}

		z_inc() {
			this.widget().z( this.widget().z() + 1 )
		}

		z_dec() {
			this.widget().z( this.widget().z() - 1 )
		}

		ref_str() {
			return this.widget().link().str
		}

		copy_code_title() {
			return '$'+'value'
		}

		copy_code() {
			return this.copy_code_template().replace( '{ref}', this.ref_str() ).replace( '#', '$' )
		}

		code_widget_tool_visible() {
			const type = this.widget().type()
			if( [ 'code', 'code_js', 'code_ts', 'code_html', 'code_sql' ].includes( type ) ) return []
			if( type === 'autoview' && !this.widget().code_widget() ) return []
			return super.code_widget_tool_visible()
		}

		preview_reload_visible() {
			if( this.widget().type() === 'iframe' ) return super.preview_reload_visible()
			if( this.widget().code_widget() ) return super.preview_reload_visible()
			if( this.widget().view_widget() ) return super.preview_reload_visible()
			if( this.widget().code_view_widget() ) return super.preview_reload_visible()
			return []
		}

		@ $mol_action
		preview_reload( next?: Event ) {
			if( next === undefined ) return null
			this.reload_view( this.Widget() )
			return next
		}

		reload_view( view: any ) {
			if( view.reload_iframe ) return view.reload_iframe()
			view.run_click?.()
			view.View?.()?.run_click?.()
			view.result?.( null )
			view.Dom_wrapper?.( null )
			view.content?.( null )
			view.sub?.( null )
			view.dom_tree?.( null )
		}

		view_widget_open() {
			const view = this.widget().code_view_widget_open()
			if( !view ) return
			this.Map_page().go_to_widget( view.link() )
			this.Map_page().selected_links( [ view.link() ] )
		}

		code_widget_open() {
			const code = this.widget().code_widget() ?? this.add_code_widget()
			if( !code ) return
			if( code.removed() ) this.map().widget_restore( code.link() )
			this.Map_page().go_to_widget( code.link() )
			this.Map_page().selected_links( [ code.link() ] )
		}

		delete() {
			this.map().widget_cut( this.widget().link() )
		}

		@ $mol_mem
		opacity( next?: number ) {
			return this.widget().opacity(next)
		}

		@ $mol_mem
		locked( next?: boolean ) {
			return this.widget().locked(next)
		}

		@ $mol_mem
		auto_height( next?: boolean ) {
			return this.widget().auto_height(next)
		}

		settings_check_visible() {
			if( this.widget().type() == 'customdom' ) return []

			return $shm_hitalama_map_widget_def_has_settings( this.widget().type() ) ? super.settings_check_visible() : []
		}

		@ $mol_mem
		settings_tool_visible() {
			return this.settings_content().length > 0 ? super.settings_tool_visible() : []
		}
		
		@ $mol_action
		add_code_widget() {
			const view = this.Widget()
			const left = view.left() + view.width()
			const top = view.top()

			const code_type = this.widget().type() == 'iframe' ? 'code_html' : 'code_js'
			const code = this.map().widget_add( code_type, [ left, top ], 800, 680 )
			code?.title( 'Code: ' + this.widget().title() )

			switch( this.widget().type() ) {
				case 'iframe':
					code?.Use_text_from( null )?.remote( this.widget() )
					break
				default:
					code?.text( `return $${''}make( '${ this.widget().type() }', {\n\t\n} )` )
					code?.enabled( true )
			}
			code?.view_widget( this.widget() )
			this.widget().code_widget( code )
			return code

		}
		
		open_in_new_uri() {
			// const dict = this.$.$mol_state_arg.dict()
			const uri = this.$.$mol_state_arg.link({ section: 'widget', widget: this.ref_str() })
			return uri
		}

		fullscreen_uri(): string {
			const uri = this.$.$mol_state_arg.link({ fullscreen_widget: this.ref_str() })
			return uri
		}

	}

}
